import React, { useState, useEffect } from "react";
import { webConfig } from "../config";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  Container,
  Modal,
  Spinner,
  Alert,
  Image,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import fileDownload from "js-file-download";
import AuthService from "../services/authServise";
import DeviceService from "../services/deviceService";
import WaitSpinner from "../components/WaitSpinner";
import { useUserContext } from "../context/userContext";
import reloadIcon from "../assets/reload.svg";
import "./Devices.css";

function Devices(props) {
  const authServise = new AuthService();
  const userContext = useUserContext();
  const deviceService = new DeviceService();

  const currentSession = authServise.getCurrentSession();

  const [devices, setDevices] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [filterDevice, setFilterDevice] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const [showInfo, setShowInfo] = useState(false);
  const [infoMsg, setInfoMsg] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const docPrefix = webConfig.LEDVANCE === "true" ? 'ledvance' : 'inventronics';
  const thirdLevel = webConfig.LEDVANCE === "true" ? "flexcuiot" : "remote-access";

  const handleClose = () => {
    setShowInfo(false);
    setInfoMsg("");
  };

  if (!authServise.isAuthenticated()) {
    authServise.login();
  }

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const showMsg = (msg) => {
    setInfoMsg(msg);
    setShowInfo(true);
  };

  useEffect(() => {
    async function checkDevices() {
      await sleep(2000);

      if (userContext.user && userContext.user != null) {
        setDevices(userContext.user.devices);

        userContext.user.devices.map(async (device) => {
          const result = await deviceService.getDeviceConnectionStatus(
            device.gatewayId,
            currentSession.accessToken
          );
          if (result != null) {
            device.online = result.online;
            device.lastConnection = result.lastConnection;
            device.statusChecked = true;
            setDevices(null);
            setDevices(userContext.user.devices);
          }
        });
      }
      setInitLoading(false);
    }
    checkDevices();
  }, [userContext.user]);

  useEffect(() => {
    if (downloading && selectedDevice) {
      function fetchData() {
        deviceService.download(selectedDevice.gatewayId).then((data) => {
          if (data !== null) {
            downloadFile(data);
            setDownloading(false);
            setSelectedDevice(null);
            showMsg("Download Done");
          } else {
            setDownloading(false);
            showMsg("No Data!");
          }
        });
      }

      fetchData();
    }
  }, [downloading]);

  useEffect(() => {
    if (uploading && selectedDevice && selectedDevice.configFile) {
      async function sendFile() {
        try {
          const result = await deviceService.upload(
            selectedDevice.configFile,
            selectedDevice.gatewayId
          );
          setUploading(false);
          setShowUploadModal(false);
          setShowInfo(true);
          setSelectedDevice(null);

          if (result === "DONE") {
            showMsg("Upload is done!");
          } else if (result === "ERROR") {
            showMsg("An ERROR has occurred!");
          }
        } catch (error) {
          setUploading(false);
          setShowUploadModal(false);
          setShowInfo(true);
          setSelectedDevice(null);
          showMsg("An ERROR has occurred!");
        }
      }
      sendFile();
    }
  }, [uploading]);

  function download(device) {
    setDownloading(true);
    if (device === selectedDevice) {
      setSelectedDevice(null);
    } else {
      setSelectedDevice(null);
      setSelectedDevice(device);
    }
  }

  function downloadFile(data) {
    if (webConfig.LEDVANCE === "true") {
      fileDownload(data, `FLEXCUIOT-${selectedDevice.sn}.osrrd`);

      return;
    }

    fileDownload(data, `DALIPro-${selectedDevice.sn}.osrrd`);
  }

  function cancelDownload() {
    setDownloading(false);
  }

  function openDeviceInfo(device) {
    if (device.systemInfo !== "") {
      const info = (
        <div className="alert alert-warning" role="alert">
          <div class="row">
            <div class="col-6 text-end">System-Name:</div>
            <div class="col-6">{device.systemInfo.systemName}</div>
          </div>
          <div class="row">
            <div class="col-6 text-end">Contact-Information:</div>
            <div class="col-6">{device.systemInfo.contactInformation}</div>
          </div>
          <div class="row">
            <div class="col-6 text-end">Address:</div>
            <div class="col-6">{device.systemInfo.address}</div>
          </div>
          <div class="row">
            <div class="col-6 text-end">Additional-Information:</div>
            <div class="col-6">{device.systemInfo.additionalInformation}</div>
          </div>
        </div>
      );
      setInfoMsg(info);
      setShowInfo(true);
    } else {
      showMsg("No Data!");
    }
  }

  const closeUploadModal = () => {
    setShowUploadModal(false);
    setSelectedDevice(null);
  };
  function refreshPage() {
    window.location.reload();
  }

  const getDevices = () => {
    let content = "";
    if (userContext.user == null) {
      return "";
    }

    if (devices === null) {
      content = (
        <Container>
          <Row className="text-center w-100 pt-5">
            <h4>NO DATA</h4>
          </Row>
          <Row className="text-center w-100 pt-5">
            <div>
              <Button
                className="btn btn-devices pt-2 text-center"
                style={{ maxWidth: 200 }}
                onClick={refreshPage}
              >
                <Image src={reloadIcon} style={{ width: 30, padding: 5 }} />{" "}
                <span>Try again</span>
              </Button>
            </div>
          </Row>
        </Container>
      );
    } else {
      content = (
        <Container>
          <Row className="w-100 justify-content-center">
            {getDevicesTable(devices)}
          </Row>

          <div>
            {/* <div class="feture-warning">
                            Please note that the free use of this feature is subject to changes. An activation key might needed in the future, in order to use the remote access functionality.
                        </div> */}

            <div class="policy">
              <a
                href={`https://${thirdLevel}.dalipro.io/docs/${docPrefix}_privacy.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                Privacy policy
              </a>
              -
              <a
                href={`https://${thirdLevel}.dalipro.io/docs/${docPrefix}_tos.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                Terms of use
              </a>
            </div>
          </div>
        </Container>
      );
    }

    return content;
  };

  const setDeviceFile = (file, device) => {
    if (file == null) {
      setSelectedDevice(null);
      device.configFile = null;
      return;
    }

    const fileExtension = file.name.replace(/^.*\./, "");
    if (fileExtension !== "osrud") {
      showMsg("Selected file format is not accepted!!!");
      setSelectedDevice(null);
      device.configFile = null;
      closeUploadModal();
    } else {
      device.configFile = file;
      setSelectedDevice(device);
    }
  };

  function filter(event) {
    setFilterDevice(event.target.value);
  }

  const openUpload = (device) => {
    setSelectedDevice(device);
    setShowUploadModal(true);
  };

  async function upload() {
    if (selectedDevice == null || selectedDevice.configFile == null) {
      showMsg(
        "Please select the configuration file first and then click on upload button!"
      );
      return;
    }
    setUploading(true);
  }

  const getDeviceStatus = (device) => {
    if (device.statusChecked) {
      return (
        <div className="text-center">
          {device.online ? (
            <div>
              <Alert
                variant="success"
                className="p-0"
                style={{ padding: 0, margin: 1 }}
              >
                <div style={{ marginLeft: 5 }}>
                  <span className="circle-green" title="online">
                    <span
                      title="online"
                      style={{ padding: 11, margin: 0, cursor: "alias" }}
                    >
                      &nbsp;
                    </span>
                  </span>
                  <span className="m-2 text-success">Online</span>
                </div>
              </Alert>
              {device.lastConnection ? (
                <span className="item-span">
                  Last connection: {device.lastConnection}
                </span>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div>
              <Alert variant="danger" style={{ padding: 0, margin: 1 }}>
                <div style={{ marginLeft: 5 }}>
                  <span className="circle-red" title="offline">
                    <span
                      title="offline"
                      style={{ padding: 11, margin: 0, cursor: "alias" }}
                    >
                      &nbsp;
                    </span>
                  </span>
                  <span className="m-2 text-danger">Offline</span>
                </div>
              </Alert>
              {device.lastConnection ? (
                <span className="item-span">
                  Last connection: {device.lastConnection}
                </span>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="text-center">
          <Alert variant="warning" className="p-0" style={{ height: "auto" }}>
            <div className="w-100 spinner-loading">
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="download-span">Loading...</span>
            </div>
          </Alert>
        </div>
      );
    }
  };

  const getDevicesTable = (devices) => {
    if (devices == null) {
      return "";
    }

    const rows = devices.map((device) => {
      return getRow(device);
    });

    return (
      <div>
        <div>
          <input
            className="w-100 p-2"
            placeholder="Search..."
            onChange={(e) => {
              filter(e);
            }}
          ></input>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr className="table-header-bg">
                <th scope="col" className="text-center">
                  SN
                </th>
                <th scope="col" className="text-center">
                  Status
                </th>
                <th scope="col" className="text-end">
                  Download / Upload
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
            <tfoot>
              <tr className="table-footer-bg">
                <td colSpan={5} className="text-end">
                  <Button
                    className="btn btn-devices p-1 text-center"
                    style={{ maxWidth: 200 }}
                    onClick={refreshPage}
                  >
                    <Image src={reloadIcon} style={{ width: 30, padding: 5 }} />{" "}
                    <span>Refresh data</span>
                  </Button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  const getRow = (device) => {
    if (
      filterDevice === "" ||
      device.sn.toString().toLowerCase().includes(filterDevice.toLowerCase()) ||
      device.name.toString().toLowerCase().includes(filterDevice.toLowerCase())
    ) {
      return (
        <tr
          key={device.sn}
          className={
            selectedDevice === device
              ? "device-item-bg-color m-0 justify-content-center"
              : "device-bg-color m-1 justify-content-center"
          }
        >
          <th scoupe="row" className="align-middle">
            <Col className="item text-center">{device.sn}</Col>
          </th>
          <td className="align-middle">
            <Col className="item text-center">{getDeviceStatus(device)}</Col>
          </td>
          <td className="align-middle">
            <Col className="text-center">
              {selectedDevice === device && downloading ? (
                <div className="w-100 spinner-loading">
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="download-span">Downloading...</span>
                  <Button
                    className="btn-devices"
                    style={{ margin: 5 }}
                    onClick={(e) => cancelDownload()}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                <Col className="text-end">
                  <Button
                    className="btn-devices"
                    disabled={!device.statusChecked || !device.online}
                    onClick={(e) => download(device)}
                  >
                    Download File
                  </Button>
                  <Button
                    className="btn-devices"
                    disabled={!device.statusChecked || !device.online}
                    onClick={(e) => openUpload(device)}
                  >
                    Upload File
                  </Button>
                </Col>
              )}
            </Col>
          </td>
        </tr>
      );
    } else {
      return "";
    }
  };

  return (
    <div className="w-100 pt-5">
      <div>{initLoading ? <WaitSpinner /> : getDevices()}</div>

      <Modal show={showInfo} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title className="text-danger">Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>{infoMsg}</b>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUploadModal}
        onHide={closeUploadModal}
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title className="text-secondary">Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="device-item-bg-color p-3">
            {uploading ? (
              <div className="w-100 spinner-loading p-2">
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Uploading...
              </div>
            ) : (
              <input
                type="file"
                id="file"
                className="input-file item"
                accept=".osrud"
                onChange={(e) =>
                  setDeviceFile(e.target.files[0], selectedDevice)
                }
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={closeUploadModal}>
            Close
          </Button>
          {!uploading ? (
            <Button className="btn-devices" onClick={(e) => upload()}>
              Upload
            </Button>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Devices;
